import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";
import { useAuth } from "../../../context/AuthContext";
import { SelfRequestForm, SelfRequestRow } from "./SelfRequestParts";

export const HrSelfAttendance = ({ onChanged }) => {
  const { user: me } = useAuth();
  const [reqs, setReqs] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => api.get("/attendance/self-requests").then((r) => setReqs(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const submit = async (form) => {
    setBusy(true);
    try {
      const r = await api.post("/attendance/self-request", form);
      toast.success(r.data.message);
      load();
    } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };

  const review = async (id, status) => {
    try {
      await api.put(`/attendance/self-requests/${id}`, { status, remarks: "" });
      toast.success(status === "approved" ? "Approved — attendance registered" : "Request rejected");
      load();
      onChanged();
    } catch (err) { toast.error(errText(err)); }
  };

  const isSA = me?.role === "super_admin";
  const pending = reqs.filter((r) => r.status === "pending");
  if (isSA && pending.length === 0) return null;

  return (
    <div className="bg-white border border-stone-200 rounded-lg" data-testid="hr-self-attendance-panel">
      <div className="p-4 border-b border-stone-100">
        <h3 className="font-heading font-bold text-sm">
          {isSA ? `HR attendance approvals (${pending.length} pending)` : "My attendance (needs Super Admin approval)"}
        </h3>
      </div>

      {!isSA && <SelfRequestForm onSubmit={submit} busy={busy} />}

      <div className="divide-y divide-stone-100">
        {reqs.length === 0 && !isSA && <p className="px-4 py-5 text-center text-sm text-stone-400">No requests yet.</p>}
        {(isSA ? pending : reqs).map((r) => (
          <SelfRequestRow key={r.id} r={r} isSuperAdmin={isSA} onReview={review} />
        ))}
      </div>
    </div>
  );
};
